"use client";

import { BlurImage, LoginImage } from "@/public/images";
import { IconGonMiniSvg } from "@/public/svg";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import { twMerge } from "tailwind-merge";

export default function Container({ children }) {
  const pathname = usePathname();

  return (
    <div className='flex flex-row justify-center min-h-screen bg-shadesGon-50'>
      <div className='px-7 py-2 sm:px-20 sm:py-9 lg:px-32 lg:py-6 w-full items-center justify-end flex'>
        <div className='h-full grid gap-2 md:gap-4 md:min-w-[350px]'>
          {/* icon */}
          <div className='flex w-full items-center justify-center '>
            <Link
              href={"/"}
              aria-label={`home`}
              shallow
              as={"/"}
              className='h-fit w-full'>
              <IconGonMiniSvg className='w-12 h-12  xl:w-18 xl:h-18  text-primaryGON-500' />
            </Link>
          </div>

          {/* body */}
          <div>{children}</div>

          {/* footer */}
          <div className={"flex items-end"}>
            <p className='p1-regular text-greyscaleGON-500 text-left'>
              Dengan menggunakan platform {process.env.COMPANY_NAME}, Anda telah
              menyetujui <br className='hidden 2xl:block' />
              <a
                href='/terms'
                aria-label='terms'
                className='text-primaryGON-400 cursor-pointer'>
                Ketentuan Layanan
              </a>{" "}
              dan{" "}
              <a
                href='/privacy'
                aria-label='privacy'
                className='text-primaryGON-400 cursor-pointer'>
                Kebijakan Privasi
              </a>
            </p>
          </div>
        </div>
      </div>
      <div
        className={twMerge(
          pathname == "/signup" ? "sticky top-0" : "",
          "hidden lg:block md:min-w-[600px] max-h-screen 2xl:min-h-screen items-center justify-center 2xl:flex overflow-hidden"
        )}>
        <div>
          <Image
            src={LoginImage}
            alt='login_image'
            className='object-cover object-bottom h-auto w-full'
            width={100}
            height={100}
            sizes='100vw, 50vw, 33vw, 25vw'
            placeholder='blur'
            blurDataURL={BlurImage?.blurDataURL}
          />
        </div>
      </div>
    </div>
  );
}
